var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// import {isProduction} from "../function/base/checkProduct"
var invokeFunc = function (key, value) {
    // todo
};
var defaultModel = {
    invokeAsync: invokeFunc,
};
var globalState = {
    model: defaultModel,
    serverUrl: '',
    billId: '',
    viewType: 'ie_test_task',
    environment: 'local',
    planList: [],
};
export var globalReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = globalState; }
    var payload = action.payload;
    switch (action.type) {
        case 'setModel':
            return __assign(__assign({}, state), { model: payload });
        case 'setEnvironment':
            return __assign(__assign({}, state), { environment: payload });
        case 'changeGlobal':
            return __assign(__assign({}, state), payload);
        case 'outputMsg':
            state.model.invokeAsync('resultData', {
                code: '0',
                message: payload,
            });
            return __assign({}, state);
        case 'getHistoryList':
            (_a = state.model) === null || _a === void 0 ? void 0 : _a.invokeAsync('ie_history_task', state.billId);
            return __assign({}, state);
        default:
            return __assign({}, state);
    }
};
